export default function getResource(label) {
    const resources = { orderSummary: 'Order Summary' };

    return resources[label];
}
